import React from 'react'
import Box from '../UI/Box'
import { Color } from '../../interfaces/designSystem'
import styled from 'styled-components'
import Flex from '@ui/Flex'

type Props = {}

const Wrap = styled(Flex)`
  flex-shrink: 0;
  padding: 8px 0;
`

const Footer = (props: Props) => {
  return (
    <Wrap
      bg={Color.DarkGrey}
      color={Color.White}
      justifyContent="center"
      fontSize={14}
      alignItems="center"
    >
      {new Date().getFullYear()} © Enhanci
    </Wrap>
  )
}

export default Footer
